// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\Billing\DraftCharge.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { ApprovalOfCharges, ApprovalOfChargesData, ApprovalOfChargesOptions } from 'data/models/ApprovalOfCharges';
import { DraftChargeCollection, DraftChargeCollectionData, DraftChargeCollectionOptions } from 'data/models/DraftChargeCollection';
import { Measurement, MeasurementData, MeasurementOptions } from 'data/models/Measurement';
import { Price, PriceData, PriceOptions } from 'data/models/Price';
import { QuickBooksInventoryItemTracking, QuickBooksInventoryItemTrackingData, QuickBooksInventoryItemTrackingOptions } from 'data/models/QuickBooksInventoryItemTracking';
import { Rate, RateData, RateOptions } from 'data/models/Rate';
import { StandardItem, StandardItemData, StandardItemOptions } from 'data/models/StandardItem';

// DraftChargeData is the class that DraftCharge serializes to/from
export interface DraftChargeData {
    Id : number;
	
    Approval : ApprovalOfChargesData | null;
    ApprovalId : number;
    ChargeCollection : DraftChargeCollectionData | null;
    ChargeCollectionId : number;
    StandardItem : StandardItemData | null;
    StandardItemId : number | null;
    StandardRate : RateData | null;
    StandardRateId : number | null;
	
    Description : string | null;
    Guid : /* GUID */ string;
    QBTrackingOverrides : QuickBooksInventoryItemTrackingData;
    Quantity : MeasurementData;
    Total : PriceData;
    Unit : MeasurementData;
    UnitPrice : PriceData;
}

// DraftChargeOptions is the class which may be passed to the DraftCharge constructor to define optional initial data values
export interface DraftChargeOptions {
    Id : number;
	
    Approval? : ApprovalOfChargesOptions | null;
    ApprovalId? : number;
    ChargeCollection? : DraftChargeCollectionOptions | null;
    ChargeCollectionId? : number;
    StandardItem? : StandardItemOptions | null;
    StandardItemId? : number | null;
    StandardRate? : RateOptions | null;
    StandardRateId? : number | null;
	
    Description? : string | null;
    Guid? : /* GUID */ string;
    QBTrackingOverrides? : QuickBooksInventoryItemTrackingOptions;
    Quantity? : MeasurementOptions;
    Unit? : MeasurementOptions;
    UnitPrice? : PriceOptions;
}

export class DraftCharge {
    public Id : DataSignal<number>;
	
    public Approval : DataSignal<ApprovalOfCharges | null>;
    public ApprovalId : DataSignal<number>;
    public ChargeCollection : DataSignal<DraftChargeCollection | null>;
    public ChargeCollectionId : DataSignal<number>;
    public StandardItem : DataSignal<StandardItem | null>;
    public StandardItemId : DataSignal<number | null>;
    public StandardRate : DataSignal<Rate | null>;
    public StandardRateId : DataSignal<number | null>;
	
    public Description : DataSignal<string | null>;
    public Guid : DataSignal<string>;
    public QBTrackingOverrides : QuickBooksInventoryItemTracking;
    public Quantity : Measurement;
    public Unit : Measurement;
    public UnitPrice : Price;

    constructor();
    constructor(data : DraftChargeOptions);
    constructor(data: DraftChargeOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Approval = S.value<ApprovalOfCharges | null>(null);
        this.ApprovalId = jsonableObservable(S.value<number>(data && data.ApprovalId !== undefined ? data.ApprovalId : 0));
        this.ChargeCollection = S.value<DraftChargeCollection | null>(null);
        this.ChargeCollectionId = jsonableObservable(S.value<number>(data && data.ChargeCollectionId !== undefined ? data.ChargeCollectionId : 0));
        this.StandardItem = S.value<StandardItem | null>(null);
        this.StandardItemId = jsonableObservable(S.value<number | null>(data && data.StandardItemId !== undefined ? data.StandardItemId : null));
        this.StandardRate = S.value<Rate | null>(null);
        this.StandardRateId = jsonableObservable(S.value<number | null>(data && data.StandardRateId !== undefined ? data.StandardRateId : null));
	    
        this.Description = jsonableObservable(S.value<string | null>(data && data.Description !== undefined ? data.Description : null));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.QBTrackingOverrides = data && data.QBTrackingOverrides !== undefined ? new QuickBooksInventoryItemTracking(data.QBTrackingOverrides) : new QuickBooksInventoryItemTracking();
        this.Quantity = data && data.Quantity !== undefined ? new Measurement(data.Quantity) : new Measurement();
        this.Unit = data && data.Unit !== undefined ? new Measurement(data.Unit) : new Measurement();
        this.UnitPrice = data && data.UnitPrice !== undefined ? new Price(data.UnitPrice) : new Price();
    }

    static key(obj : DraftCharge) {
        return obj.Id();
    }
    
    static dataKey(obj : DraftChargeOptions) {
        return obj.Id;
    }

    static update(obj : DraftCharge, data : DraftChargeOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.ApprovalId !== undefined) obj.ApprovalId(data.ApprovalId);
            if (data.ChargeCollectionId !== undefined) obj.ChargeCollectionId(data.ChargeCollectionId);
            if (data.StandardItemId !== undefined) obj.StandardItemId(data.StandardItemId);
            if (data.StandardRateId !== undefined) obj.StandardRateId(data.StandardRateId);
	        
            if (data.Description !== undefined) obj.Description(data.Description);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.QBTrackingOverrides !== undefined) QuickBooksInventoryItemTracking.update(obj.QBTrackingOverrides, data.QBTrackingOverrides);
            if (data.Quantity !== undefined) Measurement.update(obj.Quantity, data.Quantity);
            if (data.Unit !== undefined) Measurement.update(obj.Unit, data.Unit);
            if (data.UnitPrice !== undefined) Price.update(obj.UnitPrice, data.UnitPrice);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/DraftCharge.ts